module.exports = require("core-js/library/fn/get-iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/get-iterator.js
// module id = 654
// module chunks = 0